import { Box, Typography, TextField } from "@mui/material";

import { Product } from "api/memberPortal/project/product/product.types";

const RejectionRationaleSection = ({ product }: { product: Product }) => {
  const niapRejectedRationale = product.rejected_rationale;
  const vendorRejectedRationale = product.vendor_rejected_rationale;
  const rejectionRationale = niapRejectedRationale || vendorRejectedRationale;
  const rejectionSource = niapRejectedRationale ? "NIAP" : "VENDOR";

  if (!rejectionRationale) return null;

  return (
    <Box className="mb-4">
      {/* WARN: Custom styling from pre standardization! */}
      {/* TODO: Standardize when you come across this!  */}
      <Typography variant="body1" className="mb-2">
        RATIONALE FOR REJECTION FROM {rejectionSource}
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={3}
        disabled
        value={rejectionRationale}
        variant="outlined"
        slotProps={{
          input: {
            readOnly: true,
          },
        }}
      />
    </Box>
  );
};

export default RejectionRationaleSection;
